export const flags = {
  ad: async () => import('./ad'),
  ae: async () => import('./ae'),
  af: async () => import('./af'),
  ag: async () => import('./ag'),
  ai: async () => import('./ai'),
  al: async () => import('./al'),
  am: async () => import('./am'),
  ao: async () => import('./ao'),
  ar: async () => import('./ar'),
  as: async () => import('./as'),
  at: async () => import('./at'),
  au: async () => import('./au'),
  aw: async () => import('./aw'),
  ax: async () => import('./ax'),
  az: async () => import('./az'),
  ba: async () => import('./ba'),
  bb: async () => import('./bb'),
  bd: async () => import('./bd'),
  be: async () => import('./be'),
  bf: async () => import('./bf'),
  bg: async () => import('./bg'),
  bh: async () => import('./bh'),
  bi: async () => import('./bi'),
  bj: async () => import('./bj'),
  bl: async () => import('./bl'),
  bm: async () => import('./bm'),
  bn: async () => import('./bn'),
  bo: async () => import('./bo'),
  'bq-1': async () => import('./bq-1'),
  'bq-2': async () => import('./bq-2'),
  bq: async () => import('./bq'),
  br: async () => import('./br'),
  bs: async () => import('./bs'),
  bt: async () => import('./bt'),
  bw: async () => import('./bw'),
  by: async () => import('./by'),
  bz: async () => import('./bz'),
  ca: async () => import('./ca'),
  cc: async () => import('./cc'),
  cd: async () => import('./cd'),
  'cd-1': async () => import('./cd-1'),
  cf: async () => import('./cf'),
  cg: async () => import('./cg'),
  ch: async () => import('./ch'),
  ck: async () => import('./ck'),
  cl: async () => import('./cl'),
  cm: async () => import('./cm'),
  cn: async () => import('./cn'),
  co: async () => import('./co'),
  cr: async () => import('./cr'),
  cu: async () => import('./cu'),
  cv: async () => import('./cv'),
  cw: async () => import('./cw'),
  cx: async () => import('./cx'),
  cy: async () => import('./cy'),
  cz: async () => import('./cz'),
  de: async () => import('./de'),
  dj: async () => import('./dj'),
  dk: async () => import('./dk'),
  dm: async () => import('./dm'),
  do: async () => import('./do'),
  ds: async () => import('./ds'),
  dz: async () => import('./dz'),
  ec: async () => import('./ec'),
  ee: async () => import('./ee'),
  eg: async () => import('./eg'),
  eh: async () => import('./eh'),
  er: async () => import('./er'),
  es: async () => import('./es'),
  eu: async () => import('./eu'),
  et: async () => import('./et'),
  fi: async () => import('./fi'),
  fj: async () => import('./fj'),
  fk: async () => import('./fk'),
  fm: async () => import('./fm'),
  fo: async () => import('./fo'),
  fr: async () => import('./fr'),
  ga: async () => import('./ga'),
  gb: async () => import('./gb'),
  'gb-2': async () => import('./gb-2'),
  gd: async () => import('./gd'),
  ge: async () => import('./ge'),
  gf: async () => import('./gf'),
  gg: async () => import('./gg'),
  gh: async () => import('./gh'),
  gi: async () => import('./gi'),
  gl: async () => import('./gl'),
  gm: async () => import('./gm'),
  gn: async () => import('./gn'),
  gp: async () => import('./gp'),
  gq: async () => import('./gq'),
  gr: async () => import('./gr'),
  gt: async () => import('./gt'),
  gu: async () => import('./gu'),
  gw: async () => import('./gw'),
  gy: async () => import('./gy'),
  hk: async () => import('./hk'),
  hn: async () => import('./hn'),
  hr: async () => import('./hr'),
  ht: async () => import('./ht'),
  hu: async () => import('./hu'),
  id: async () => import('./id'),
  ie: async () => import('./ie'),
  il: async () => import('./il'),
  im: async () => import('./im'),
  in: async () => import('./in'),
  io: async () => import('./io'),
  iq: async () => import('./iq'),
  ir: async () => import('./ir'),
  is: async () => import('./is'),
  it: async () => import('./it'),
  je: async () => import('./je'),
  jm: async () => import('./jm'),
  jo: async () => import('./jo'),
  jp: async () => import('./jp'),
  ke: async () => import('./ke'),
  kg: async () => import('./kg'),
  kh: async () => import('./kh'),
  ki: async () => import('./ki'),
  km: async () => import('./km'),
  kn: async () => import('./kn'),
  kp: async () => import('./kp'),
  kr: async () => import('./kr'),
  kw: async () => import('./kw'),
  ky: async () => import('./ky'),
  kz: async () => import('./kz'),
  la: async () => import('./la'),
  lb: async () => import('./lb'),
  lc: async () => import('./lc'),
  li: async () => import('./li'),
  lk: async () => import('./lk'),
  lr: async () => import('./lr'),
  ls: async () => import('./ls'),
  lt: async () => import('./lt'),
  lu: async () => import('./lu'),
  lv: async () => import('./lv'),
  ly: async () => import('./ly'),
  ma: async () => import('./ma'),
  mc: async () => import('./mc'),
  md: async () => import('./md'),
  me: async () => import('./me'),
  mg: async () => import('./mg'),
  mh: async () => import('./mh'),
  mk: async () => import('./mk'),
  ml: async () => import('./ml'),
  mm: async () => import('./mm'),
  mn: async () => import('./mn'),
  mo: async () => import('./mo'),
  mp: async () => import('./mp'),
  mq: async () => import('./mq'),
  mr: async () => import('./mr'),
  ms: async () => import('./ms'),
  mt: async () => import('./mt'),
  mu: async () => import('./mu'),
  mv: async () => import('./mv'),
  mw: async () => import('./mw'),
  mx: async () => import('./mx'),
  my: async () => import('./my'),
  mz: async () => import('./mz'),
  na: async () => import('./na'),
  nc: async () => import('./nc'),
  ne: async () => import('./ne'),
  nf: async () => import('./nf'),
  ng: async () => import('./ng'),
  ni: async () => import('./ni'),
  nl: async () => import('./nl'),
  no: async () => import('./no'),
  np: async () => import('./np'),
  nr: async () => import('./nr'),
  nu: async () => import('./nu'),
  nz: async () => import('./nz'),
  om: async () => import('./om'),
  pa: async () => import('./pa'),
  pe: async () => import('./pe'),
  pf: async () => import('./pf'),
  pg: async () => import('./pg'),
  ph: async () => import('./ph'),
  pk: async () => import('./pk'),
  pl: async () => import('./pl'),
  pn: async () => import('./pn'),
  pr: async () => import('./pr'),
  ps: async () => import('./ps'),
  pt: async () => import('./pt'),
  pw: async () => import('./pw'),
  py: async () => import('./py'),
  qa: async () => import('./qa'),
  re: async () => import('./re'),
  ro: async () => import('./ro'),
  rs: async () => import('./rs'),
  ru: async () => import('./ru'),
  rw: async () => import('./rw'),
  sa: async () => import('./sa'),
  sb: async () => import('./sb'),
  sc: async () => import('./sc'),
  sd: async () => import('./sd'),
  se: async () => import('./se'),
  sg: async () => import('./sg'),
  si: async () => import('./si'),
  sk: async () => import('./sk'),
  sl: async () => import('./sl'),
  sm: async () => import('./sm'),
  sn: async () => import('./sn'),
  so: async () => import('./so'),
  sr: async () => import('./sr'),
  ss: async () => import('./ss'),
  st: async () => import('./st'),
  sv: async () => import('./sv'),
  sx: async () => import('./sx'),
  sy: async () => import('./sy'),
  sz: async () => import('./sz'),
  tc: async () => import('./tc'),
  td: async () => import('./td'),
  tg: async () => import('./tg'),
  th: async () => import('./th'),
  tj: async () => import('./tj'),
  tk: async () => import('./tk'),
  tl: async () => import('./tl'),
  tm: async () => import('./tm'),
  tn: async () => import('./tn'),
  to: async () => import('./to'),
  tr: async () => import('./tr'),
  tt: async () => import('./tt'),
  tv: async () => import('./tv'),
  tw: async () => import('./tw'),
  tz: async () => import('./tz'),
  ua: async () => import('./ua'),
  ug: async () => import('./ug'),
  us: async () => import('./us'),
  uy: async () => import('./uy'),
  uz: async () => import('./uz'),
  va: async () => import('./va'),
  vc: async () => import('./vc'),
  ve: async () => import('./ve'),
  vg: async () => import('./vg'),
  vi: async () => import('./vi'),
  vn: async () => import('./vn'),
  vu: async () => import('./vu'),
  ws: async () => import('./ws'),
  xk: async () => import('./xk'),
  ye: async () => import('./ye'),
  za: async () => import('./za'),
  zm: async () => import('./zm'),
  zw: async () => import('./zw'),
};
